import { faSpinnerThird, faUserShield } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Col, Flex, Form, Input, Row, Tooltip, Typography } from "antd"
import { useContext } from "react"
import VSpace from "../../common/VSpace"
import TenantsContext from "../TenantsContext"
import { generatePasswordStrengthMessage } from "../tenantsModel"

const { Title, Text } = Typography

const AdministratorAccountSection = () => {
  const { state: { adminAccount }, dispatch, isEmailAvailable, isEmailValid, isEmailValidationLoading } = useContext(TenantsContext)

  return <section>
    <Title level={5}><FontAwesomeIcon icon={faUserShield} /> Admin Account</Title>
    <VSpace>
      <Text>Tenants must all have at least one account in the administrator role. Enter an email address and password below to create this account when saving the tenant details.</Text>
      <Text>The password must contain at least one uppercase letter, one lowercase letter, one special character, and be at least 8 characters long.</Text>
      <Row gutter={24}>
        <Col span={6}>
          <Form.Item label="Full Name">
            <Input
              value={adminAccount?.displayName}
              onChange={e => dispatch({ type: 'SET_ADMIN_ACCOUNT_FIELD', fieldName: 'displayName', payload: e.target.value })}
            />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="Email">
            <Input
              value={adminAccount?.email}
              status={!isEmailAvailable && isEmailValid && !isEmailValidationLoading ? 'error' : ''}
              onChange={e => dispatch({ type: 'SET_ADMIN_ACCOUNT_FIELD', fieldName: 'email', payload: e.target.value })}
              style={{ 
                borderColor: !isEmailAvailable && isEmailValid && !isEmailValidationLoading ? 'red' : '', 
                borderWidth: 1 
              }}
            />
            {
              !isEmailValid && adminAccount?.email && <Text type='danger'>Invalid email</Text>
            }
            {
              !isEmailAvailable && isEmailValid && !isEmailValidationLoading  && <Text type='danger'>Email is already in use</Text>
            }
          </Form.Item>
        </Col>
        {
          isEmailValidationLoading && <Flex vertical justify='center'>
            <FontAwesomeIcon icon={faSpinnerThird} spin speed={20} />
          </Flex>
        }
        <Col span={6}>
          <Tooltip title="The password must contain at least one uppercase letter, one lowercase letter, one special character, and be at least 8 characters long.">
            <Form.Item label="Password">
              <Input
                value={adminAccount?.password}
                onChange={e => dispatch({ type: 'SET_ADMIN_ACCOUNT_FIELD', fieldName: 'password', payload: e.target.value })}
              />
              {
                adminAccount?.password && <Text type='danger'>{generatePasswordStrengthMessage(adminAccount.password)}</Text>
              }
            </Form.Item>
          </Tooltip>
        </Col>
      </Row>
    </VSpace>
  </section>
}

export default AdministratorAccountSection